<wa-dialog class="image-lightbox" label="Screenshot" without-header [open]="image() !== null" (wa-hide)="onHide($event)">
    @if (image(); as img) {
        <!-- Backdrop click-to-close is a pointer convenience; keyboard users have Escape and the close button. -->
        <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus, @angular-eslint/template/click-events-have-key-events -->
        <div class="lightbox-body" data-testid="image-lightbox" (click)="onBackdropClick($event)">
            <wa-button appearance="filled" class="lightbox-close" size="m" variant="neutral" (click)="close()">
                <wa-icon label="Close" name="xmark" variant="regular" />
            </wa-button>
            <img class="lightbox-image" [alt]="img.caption || 'Screenshot'" [src]="img.url" />
            @if (editable()) {
                <wa-textarea
                    class="lightbox-caption-input"
                    label="Caption"
                    placeholder="Add a caption…"
                    resize="none"
                    rows="2"
                    [value]="img.caption ?? ''"
                    (input)="onCaptionInput($event)" />
            } @else if (img.caption) {
                <p class="lightbox-caption" data-testid="lightbox-caption">{{ img.caption }}</p>
            }
        </div>
    }
</wa-dialog>
